import { IBBetriebRouteDefs } from "../../../routing/IBBetriebRouteDefs";

export class IBBetriebZweigwerkRouteDefs {
  public static FEATURE_PATH = "zweigwerk";
  public static PARAM_ID = "Id";

  public static FQ_PATH = `${IBBetriebRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}`;
  public static LIST_PATH = "list";
  public static LIST_FQ_PATH = `${IBBetriebRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.LIST_PATH}`;
  public static CREATE_PATH = "create";
  public static CREATE_FQ_PATH = `${IBBetriebRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.CREATE_PATH}`;
  public static UPDATE_PATH = `:${this.PARAM_ID}`;
  public static UPDATE_FQ_PATH = `${IBBetriebRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.UPDATE_PATH}`;

  public static getFQR = () => this.FQ_PATH;

  public static getFQRList = () => this.LIST_FQ_PATH;

  public static getFQRCreate = () => this.CREATE_FQ_PATH;

  public static getFQRUpdate = (id: string) => this.UPDATE_FQ_PATH.replace(this.UPDATE_PATH, id);
}
